<template>
    <div>
        <v-toolbar flat height="36" class="my-3">
            <v-toolbar-title>{{ $localize('ApiKeys.title') }}</v-toolbar-title>

            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    class="primary btnAddApiKey"
                    @click="createApiKey = true"
                >
                    <v-icon class="mr-1">mdi-plus</v-icon>
                    {{ $localize('ApiKeys.button.create') }}</v-btn
                >
            </v-toolbar-items>
        </v-toolbar>
        <v-data-table
            :items="apiKeys"
            :headers="headers"
            :footer-props="{ 'items-per-page-options': [10, 20, 50, -1] }"
            :options.sync="options"
            :loading="loading"
            dense
        >
            <template v-slot:[`item.status`]="{ item }">
                <v-icon v-if="isExpired(item.expires)">mdi-alert</v-icon>
                <v-icon v-else>mdi-check</v-icon>
            </template>
            <template v-slot:[`item.created`]="{ item }">{{
                $format.shortDate(item.created)
            }}</template>
            <template v-slot:[`item.expires`]="{ item }">{{
                $format.shortDate(item.expires)
            }}</template>
            <template v-slot:[`item.lastUse`]="{ item }">{{
                $format.shortDate(item.lastUse) ||
                $localize('ApiKeys.lastUse.never')
            }}</template>
            <template v-slot:[`item.keyHint`]="{ item }"
                >******{{ item.keyHint }}</template
            >
            <template v-slot:[`item.action`]="{ item }">
                <table-toolbar>
                    <v-btn
                        small
                        depressed
                        @click="
                            deleteApiKeyObj = item
                            deleteApiKey = true
                        "
                        class="btnDeleteApiKey"
                    >
                        <v-icon dense>mdi-close</v-icon>
                    </v-btn>
                </table-toolbar>
            </template>
        </v-data-table>
        <delete-api-key
            :api-key-id="deleteApiKeyObj?.apiKeyId"
            v-model="deleteApiKey"
            @saved="refresh"
        />
        <create-api-key v-model="createApiKey" @saved="refresh" />
    </div>
</template>

<script>
import DeleteApiKey from './dialogs/DeleteApiKey'
import CreateApiKey from './dialogs/CreateApiKey'
import { getApiKeys } from '@/services/api'
import { parseISO, isPast } from 'date-fns'
export default {
    components: { DeleteApiKey, CreateApiKey },
    data() {
        return {
            deleteApiKeyObj: null,
            deleteApiKey: false,
            createApiKey: false,
            loading: false,
            apiKeys: [
                {
                    keyId: 'guid',
                    name: 'MyKey',
                    created: '2023-05-11',
                    expires: '2024-05-11',
                    lastUse: null,
                    keyHint: 'sf3aq',
                },
                {
                    keyId: 'guid',
                    name: 'MyKey 2',
                    created: '2026-05-11',
                    expires: '2027-05-11',
                    lastUse: null,
                    keyHint: '3s8kf',
                },
            ],
            headers: [
                { text: '', value: 'status', width: 30 },
                { text: this.$localize('ApiKey.name'), value: 'name' },
                { text: this.$localize('ApiKey.created'), value: 'created' },
                { text: this.$localize('ApiKey.expires'), value: 'expires' },
                { text: this.$localize('ApiKey.lastUse'), value: 'lastUse' },
                { text: this.$localize('ApiKey.userName'), value: 'lastUse' },
                { text: this.$localize('ApiKey.key'), value: 'keyHint' },
                {
                    value: 'action',
                    sortable: false,
                    width: 150,
                },
            ],
            options: JSON.parse(localStorage.getItem('ApiKeys:options')) || {
                itemsPerPage: -1,
            },
        }
    },
    watch: {
        options() {
            localStorage.setItem(
                'ApiKeys:options',
                JSON.stringify(this.options)
            )
        },
    },
    created() {
        this.refresh()
    },
    methods: {
        isExpired(expires) {
            if (expires) {
                const expiresDate = parseISO(expires)
                return isPast(expiresDate)
            }
            return false
        },
        async refresh() {
            this.loading = true
            const { result, ok } = await getApiKeys.call()
            if (ok) {
                this.apiKeys = result
            }
            this.loading = false
        },
    },
}
</script>
